import { render, staticRenderFns } from "./NbCustomerTypeAhead.vue?vue&type=template&id=24d6d5a7&"
import script from "./NbCustomerTypeAhead.vue?vue&type=script&lang=js&"
export * from "./NbCustomerTypeAhead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports